import type { ReactNode } from "react";
import { LoadingSpinner } from "./LoadingSpinner";
import clsx from "clsx";

type ButtonProps = {
  children: ReactNode,
  onClick?: () => void
  upperCased?: boolean
  submit?: boolean
  disabled?: boolean
  secondary?: boolean
  bolder?: boolean
  isLoading?: boolean
  style?: React.CSSProperties
  className?: string
}

export const Button = ({
  children,
  onClick,
  upperCased,
  submit,
  disabled,
  secondary,
  bolder,
  isLoading,
  style,
  className,
}: ButtonProps) => {
  const isDisabled = disabled || isLoading;

  return (
    <button
      type={submit ? "submit" : "button"}
      onClick={onClick}
      disabled={isDisabled}
      style={style}
      className={clsx(
        "block mx-auto py-3 px-6 rounded-[58px]",
        "shadow-[0px_4px_4px_#00000017]",
        "text-center leading-normal border-2",
        "transition-colors duration-200",
        "cursor-pointer",
        bolder ? "font-black" : "font-medium",
        upperCased && "uppercase",
        !secondary && [
          "bg-[var(--color-primary-1)]",
          "border-[var(--color-primary-1)]",
          "text-white",
          "hover:bg-white",
          "hover:text-[var(--color-primary-1)]",
        ],
        secondary && [
          "bg-transparent",
          "border-transparent",
          "text-[var(--color-primary-1)]",
          "hover:bg-white",
        ],
        isDisabled &&
          (secondary
            ? "text-gray-400 border-gray-300 cursor-not-allowed hover:bg-transparent"
            : "bg-gray-300 border-gray-300 text-white cursor-not-allowed hover:bg-gray-300 hover:text-white"),
        className,
      )}
    >
      {isLoading ? (
        <LoadingSpinner sm color="white" />
      ) : (
        children
      )}
    </button>
  );
};